// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__32qO5","header":"PatientBlock_header__3yxkU","label":"PatientBlock_label__3CKYx","option":"PatientBlock_option__2Plfg"};